export default function NotFound() {
  return (
    <div style={{ marginTop: 50, fontSize: '22px', textAlign: 'center' }}>
      <h1>404 Page Not Found</h1>
    </div>
  );
}
